/* Copyright (C) ZibatRan , Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */
import React, { useState } from 'react';
import { Button, Form, Modal } from "antd";
import loadingWhite from "../../assets/images/loading_white.svg";
import { protectedPostData, delData, getData } from "../../api/Interface";
import { openNotificationWithIcon } from "../../Helper";

const CustomConfirmationSecond = (props) => {

    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const stateChanger = () => {
        setVisible(!visible);
    };

    const Delete = async () => {
        if (localStorage.getItem("zibatran-user-data") && JSON.parse(localStorage.getItem("zibatran-user-data")).user_data.phone === "09120088800") {
            openNotificationWithIcon('error', "عدم دسترسی", "شما مجاز به انجام این عملیات نیستید");
        } else {
            setLoading(true);
            let response
            if (props.deleteMethod) {
                response = await delData(props.Link, props.RequestBody);
            } else if (props.Method === "get") {
                response = await getData(props.Link, props.RequestBody);
            } else if (props.Method === "NOLINK") {
                props.onDeleted();
                stateChanger();
            } else {
                response = await protectedPostData(props.Link, props.RequestBody);
            }
            if (response) {
                props.onDeleted(Math.random());
                stateChanger();
            }
            setLoading(false);
        }
    };


    return (

        <>
            <div onClick={stateChanger} style={{ display: 'inline-block' }} className={props.classBtn}>
                {props.Item && props.Item}
            </div>

            <Modal
                centered
                closable={true}
                closeIcon={<div onClick={stateChanger}><i style={{ fontWeight: 'bold' }}
                    className=" fal fa-times" /></div>}
                visible={visible}
                header={false}
                footer={false}
                bodyStyle={{
                    backgroundColor: "#FFF",
                    borderRadius: 15,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div className="ModalBodyContainerOne">

                    <p>{props.title}</p>

                    <p className="text-left">{props.description}</p>

                    <Form className="col-12"
                        onFinish={!loading && Delete}
                    >

                        <Form.Item>
                            <Button htmlType="submit" className={`buttonStyleOne ${props.yesColor}`}>

                                {loading ?

                                    <img src={loadingWhite}
                                        alt="Loading ..."
                                        width="40"
                                        height="22"
                                    />
                                    :
                                    props.yesName
                                }
                            </Button>
                        </Form.Item>

                        <Form.Item>

                            <Button className={`buttonStyleOne ${props.noColor}`}
                                onClick={stateChanger}>
                                {props.noName}

                            </Button>
                        </Form.Item>


                    </Form>


                </div>
            </Modal>

        </>

    )
};

export default CustomConfirmationSecond;
